import { SupersedeStatus, SupersedingKind } from '@/models/api/commerce-sales-order'

interface MinimumOrderDependencies {
  supersedeStatus?: SupersedeStatus
  supersedingKind?: SupersedingKind
}

export function getEditedOrderMessage(order: MinimumOrderDependencies): string | null {
  if (isEditedOrder(order)) {
    return `ご注文内容が変更されました。<br>
    ご注文内容の変更に伴い、ご注文番号も変更となっております。`
  }

  return null
}

function isEditedOrder(order: MinimumOrderDependencies): boolean {
  return order.supersedeStatus === 'active' && order.supersedingKind === 'admin'
}

/**
 * ユーザー操作による再注文である
 *
 * @see https://github.com/Everforth/growthpalette-front/issues/7843#issuecomment-1977781398
 */
export function isReorderByUser(order: MinimumOrderDependencies): boolean {
  return order.supersedeStatus === 'active' && order.supersedingKind === 'user'
}
